import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Youtube, Send, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export function Footer() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/newsletter", { email });
      setDone(true);
      toast.success("Merci ! Vous êtes inscrit·e à notre newsletter.");
      setEmail("");
    } catch {
      toast.error("Inscription impossible, réessayez.");
    }
  };

  const cols = [
    { title: "Boutique", links: [["Canapés d'Angle", "/canapes?category=canapes-angle"], ["Canapés Convertibles", "/canapes?category=canapes-convertibles"], ["Lits & Boxspring", "/canapes?category=lits"], ["Tous les modèles", "/canapes"], ["Nouveautés", "/canapes?sort=newest"]] },
    { title: "Maison", links: [["À propos", "/a-propos"], ["Nos ateliers", "/a-propos"], ["Contact", "/contact"], ["Nouveautés", "/canapes?sort=newest"]] },
    { title: "Aide", links: [["Livraison", "/contact"], ["Retours", "/contact"], ["CGV", "/contact"], ["Confidentialité", "/contact"], ["FAQ", "/contact"]] },
  ];

  return (
    <footer className="bg-obsidian text-cream" data-testid="main-footer">
      {/* Newsletter */}
      <div className="border-b border-obsidian-border">
        <div className="mx-auto grid max-w-7xl gap-8 px-6 py-16 lg:grid-cols-2 lg:items-center lg:px-8">
          <div>
            <p className="mb-2 font-accent text-xs uppercase tracking-[0.25em] text-gold">Newsletter</p>
            <h3 className="font-serif text-3xl text-cream lg:text-4xl">Recevez nos nouveautés & offres privées</h3>
            <p className="mt-3 max-w-md text-sm text-cream/60">Inspiration déco, avant-premières et ventes privées directement dans votre boîte mail.</p>
          </div>
          <form onSubmit={subscribe} className="flex w-full max-w-lg items-center gap-2 rounded-full border border-obsidian-border bg-obsidian-card p-1.5 lg:ml-auto" data-testid="newsletter-form">
            <input
              type="email"
              required
              data-testid="newsletter-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Votre adresse email"
              className="flex-1 bg-transparent px-5 py-3 text-sm text-cream placeholder:text-cream/40 outline-none"
            />
            <button data-testid="newsletter-submit" className="flex items-center gap-2 rounded-full bg-gold-gradient px-6 py-3 text-sm font-semibold text-obsidian transition-transform hover:scale-[1.03]">
              {done ? <CheckCircle2 size={16} /> : <Send size={16} />}
              {done ? "Inscrit" : "S'inscrire"}
            </button>
          </form>
        </div>
      </div>

      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 md:grid-cols-2 lg:grid-cols-5 lg:px-8">
        <div className="lg:col-span-2">
          <span className="font-serif text-3xl">shop<span className="text-gold">·</span>canapé</span>
          <p className="mt-4 max-w-xs text-sm text-cream/60">
            Maison française de canapés d'exception. Chaque pièce est façonnée à la main dans nos ateliers européens pour transformer votre intérieur.
          </p>
          <div className="mt-6 flex gap-3">
            {[Instagram, Facebook, Twitter, Youtube].map((Icon, i) => (
              <a key={i} href="#" aria-label="Réseau social" data-testid={`footer-social-${i}`} className="flex h-10 w-10 items-center justify-center rounded-full border border-obsidian-border text-cream/70 transition-all hover:border-gold hover:bg-gold hover:text-obsidian">
                <Icon size={17} />
              </a>
            ))}
          </div>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="mb-4 font-accent text-xs uppercase tracking-[0.2em] text-gold">{c.title}</h4>
            <ul className="space-y-2.5">
              {c.links.map(([label, to]) => (
                <li key={label}>
                  <Link to={to} className="text-sm text-cream/60 transition-colors hover:text-cream">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-obsidian-border">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 py-6 text-xs text-cream/50 md:flex-row lg:px-8">
          <p>© {new Date().getFullYear()} shop-canapé. Tous droits réservés.</p>
          <div className="flex items-center gap-3">
            <span className="text-cream/40">Paiement sécurisé</span>
            {["VISA", "MASTERCARD", "AMEX", "PAYPAL"].map((p) => (
              <span key={p} className="rounded-md border border-obsidian-border bg-obsidian-card px-2.5 py-1 text-[10px] font-semibold tracking-wider text-cream/70">{p}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
